import React from 'react';
import { Menu } from 'antd';
import { Link } from 'dva/router';
import { connect } from 'dva';
import styles from './index.css';

class Nav extends React.Component {

	render() {
		console.log("Nav cur_path", this.props.cur_path);
		let contactFlag = false;
		if (this.props.cur_path == '/about' && window.location.hash == '#contact') {
			contactFlag = true;
		}
		console.log("Nav contactFlag", contactFlag);
		return (
			<div className={styles.menu_wrap_style}>
				<img alt="" src="https://img.cgwrite.cn/qa/up/2508/276281.png" style={{ width: '150px', marginRight: '100px' }} />
				<Menu
					//selectedKeys={[this.props.cur_path]}
					mode="horizontal"
					theme='light'
					style={{ width: '500px', height: "74px", display: 'flex', justifyContent: 'flex-start', alignItems: 'center', border: 'none', background: '#E6FBD2' }}
				>
					{this.props.route.map(item => {
						let isActive = item.path && new RegExp(`^${item.path}$`).test(String(this.props.cur_path));
						if (contactFlag) {
							isActive = false;
						}
						return <Menu.Item key={(item.path) || item.url}
							className={isActive ? styles.cur_menu : styles.menu}
							style={{
								minWidth: '70px',
								textAlign: 'center',
								border: 'none',
							}}>
							{item.path
								? <Link to={item.path}>{item.nav_name}</Link>
								: <a target='_blank' href={item.url}>{item.nav_name}</a>
							}
						</Menu.Item>
					})}
				</Menu>
				<div style={{
					width: '100px', height: '40px', lineHeight: "40px", marginLeft: '30px', marginTop: '-5px',
					textAlign: 'center', background: "#EAB946", borderRadius: '20px'
				}}><Link to="/about#contact" style={{ fontSize: '18px', color: '#ffffff' }}>联系编辑</Link></div>
			</div>
		);
	}
}

const state_props = state => {
	return {
		cur_path: state.app.path,
	}
}

export default connect(state_props)(Nav);



// WEBPACK FOOTER //
// ./src/component/nav/index.js